import React, { useEffect } from "react";
import "./CashierStyle.css";

export interface CashierImagePreviewProps {
  src: string;
  alt?: string;
  open: boolean;
  onClose: () => void;
}

export const CashierImagePreview: React.FC<CashierImagePreviewProps> = ({
  src,
  alt = "",
  open,
  onClose,
}) => {
  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  if (!open) {
    return null;
  }

  return (
    <div
      className="cashier-image-preview-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="查看大图"
      onClick={onClose}
    >
      <button
        type="button"
        className="cashier-image-preview-close"
        aria-label="关闭"
        onClick={onClose}
      >
        ×
      </button>
      <img
        className="cashier-image-preview-img"
        src={src}
        alt={alt}
        onClick={(event) => event.stopPropagation()}
      />
    </div>
  );
};
